import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import assets from 'modules/assets'
import { Link } from 'react-router'

class RowThreeImage extends Component {
  constructor(props) {
    super(props)
    this.state = { ...props }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  navigateToLink(url) {
    window.open(url, '_blank')
  }
  parse(content) {
    if (typeof content === 'undefined') {
      return ''
    }

    // TODO: refactor/clean up
    return content && content.map((el, i) => {
      switch (el.type) {
        case 'image':
          return (
            <div> <img src={assets(el.src)}/> </div>
          )
        case 'h1':
            return el.content.map((label, i) => { return <h1 style={{lineHeight: '1.1'}}key={i}>{label}</h1> })
        case 'h2':
            return el.content.map((label, i) => { return <h2 key={i}>{label}</h2> })
        case 'h3':
            let isSectraLight = el.style == 'sectra-light'
            return (
              el.content.map((label, i) => {
                let className = (i > 0 || isSectraLight) ? 'sectra-light' : ''
                let style = (label === '' && window.innerWidth > 480) ? {minHeight: '28px'} : {}
                return <h3 key={i} className={className} style={style}>{label}</h3>
              })
            )
      }
    })
  }
  render() {
    let data
    if (this.state && this.state.data) {
      data = this.state.data
    }

    return (
      <section className="main-grid center">
        <ul className="grid group">

          <li className="grid-small fade-in">
            { this.parse(data && data.content[0]) }
          </li>

          <li className="grid-large fade-in" style={{'marginLeft': '2%'}}>
            { this.parse(data && data.content[1]) }
          </li>

        </ul>
      </section>
    )
  }
}
RowThreeImage.contextTypes = {
}
RowThreeImage.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(RowThreeImage)



// WEBPACK FOOTER //
// ./src/components/Utils/RowThreeImage.js